export enum BoundaryType {
	COUNTRY = 'COUNTRY',
	STATE = 'STATE',
	US_COUNTY = 'US_COUNTY',
	POSTAL = 'POSTAL'
}
